export const polygonVertices16 = "M0 14v2h2v-1h12v1h2v-2h-1V2h1V0h-2v1.735L6.833 7 2 4.514V3H0v2h1v9zm2-8.361l4 2.057V9h2V7.384l6-4.408V14H2z";
